import { useEffect, useState } from "react";

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";

import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { changeMemberPasswordWithId, createMemberAccount, deleteChatWithId, deleteMemberWithId, loadAllStaff } from "./data/API";
import SearchField from "./mui/SearchField";
import { ToastContainer, toast } from "react-toastify";
import { Delete, Password } from "@mui/icons-material";
import { Toaster } from "react-hot-toast";

function BasicTable({ list, loadStaff }) {


    const [toDelete, setToDelete] = useState(null);
    const [toChangePassword, setToChangePassword] = useState(null);


    function deleteMember() {
        const id = toDelete.id;

        toast("Deleting Member");
        deleteMemberWithId(id, (err, data) => {
            loadStaff();

        });
        setToDelete(null);


    }

    function changePassword() {
        if(newPassword==''){
            toast("Please Enter New Password");
            return;
        }
        const id = toChangePassword.id

        toast("Saving Password");
        changeMemberPasswordWithId(id,newPassword, (err, data) => {
            loadStaff();
        });
        setToChangePassword(null);
    }

    const [newPassword,setNewPassword] = useState('');

    

    return (
        <TableContainer component={Paper}>
            <Toaster/>

            <Dialog open={toChangePassword != null} fullWidth>
                <DialogTitle className="bg-red-500 text-white ">Change Password</DialogTitle>
                <DialogContent className="flex flex-col gap-2  text-[25px]" >
          
                    <TextField 
                    color="error"
                    InputProps={{sx:{borderRadius:10}}}
                    sx={{marginTop:4}}
                    label="Enter New Password"
                    onChange={(e)=>setNewPassword(e.target.value)}
                    value={[newPassword]}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={changePassword} color="error">
                        Change
                    </Button>
                    <Button variant="contained" onClick={() => (setToChangePassword(null))}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>






            <Dialog open={toDelete != null}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    Are you sure to delete this account?
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={deleteMember} color="error">
                        Delete
                    </Button>
                    <Button variant="contained" onClick={() => (setToDelete(null))}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>FULL NAME</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                            ROLE
                        </TableCell>

                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                            PHONE
                        </TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                            EMAIL
                        </TableCell>

                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                            DATE CREATED
                        </TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                            ACTION
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((row) => (
                        <TableRow
                            key={row.id}
                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.first_name}
                            </TableCell>
                            <TableCell align="left" style={{ color: "green" }}>
                                {row.user_type.replace('_', ' ')}
                            </TableCell>
                            <TableCell align="left">{row.phone}</TableCell>
                            <TableCell align="left">{row.email}</TableCell>

                            <TableCell align="left">{row.created_at.replace('T', ' ').split('.')[0]}</TableCell>
                            <TableCell align="left">
                                <Password className="cursor-pointer" onClick={() => setToChangePassword(row)} color="primary" />

                                <Delete onClick={() => setToDelete(row)} color="error" />

                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default function StaffManagement() {
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState();

    function getUsers() {
        loadAllStaff((err, data) => {
            if (err) {
                setLoading(false);
                console.log(err);
            } else {
                setLoading(false);
                setUsers(data);
            }
        });
    }

    useEffect(() => {
        getUsers();
    }, []);

    function getFilteredUsers() {
        return users.filter(
            (e) =>
                e.user_type == "admin" ||
                e.user_type == "finance_manager" ||
                e.user_type == "vendor_manager" ||
                e.user_type == "customer_support"

        );
    }

    const [query, setQuery] = useState("");

    const [addMember, setAddMember] = useState(false);

    const options = [
        {
            label: "Admin",
            value: "admin",
        },
        {
            label: "Vendor Manager",
            value: "vendor_manager",
        },
        {
            label: "Finance Manager",
            value: "finance_manager",
        },
        {
            label: "Customer Support Agent",
            value: "customer_support",
        },
    ];

    const [memberType, setMemberType] = useState(options[0].value);


    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    const [name, setName] = useState('');

    const [password, setPassword] = useState('');

    function saveAccount() {


        if (phone == '' || email == '' || name == '' || password == '') {
            toast('Please fill all data')
            return;
        }

        setLoading(true);




        setAddMember(false);
        createMemberAccount({ 'full_name': name, 'email': email, 'password': password, 'user_type': memberType, 'phone': phone }, (err, data) => {

            toast(data['error']);

            setLoading(false);



            getUsers();


        })






    }
    function getAddMemberDialog() {
        return (
            <Dialog open={addMember} fullWidth onClose={() => setAddMember(false)}>
                <DialogTitle className="bg-green-500 text-white">
                    Enter Member Details
                </DialogTitle>

                <DialogContent className="flex flex-col gap-2">
                    <div className="mt-8 flex-col gap-1 flex">
                        <TextField
                            fullWidth
                            InputProps={{
                                sx: { borderRadius: 6, fontSize: 16, marginTop: 1 },

                            }}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            color="success"
                            placeholder="Please Enter Member Name"
                        />
                        <div className="flex flex-row gap-3">
                            <TextField
                                fullWidth
                                InputProps={{
                                    sx: { borderRadius: 6, fontSize: 16, marginTop: 1 },
                                }}
                                color="success"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Please Enter Email"
                            />

                            <Select
                                color="success"
                                sx={{ borderRadius: 10 }}
                                fullWidth
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={memberType}
                                onChange={(e) => setMemberType(e.target.value)}
                            >
                                {options.map((option, index) => (
                                    <MenuItem key={index} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <TextField
                            fullWidth
                            InputProps={{
                                sx: { borderRadius: 6, fontSize: 16, marginTop: 1 },
                                inputProps: {
                                    step: "any", // Allows decimal numbers
                                    inputMode: "numeric",
                                },
                            }}
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            color="success"
                            placeholder="Please Enter Phone Number"
                        />

                        <TextField
                            fullWidth
                            InputProps={{
                                sx: { borderRadius: 6, fontSize: 16, marginTop: 1 },

                            }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            color="success"
                            placeholder="Please Enter Password"
                        />
                    </div>
                </DialogContent>

                <DialogActions sx={{ paddingX: 10, paddingY: 5 }}>
                    <Button
                        sx={{ borderRadius: 10, textTransform: "capitalize", paddingX: 5 }}
                        onClick={() => saveAccount()}
                        variant="contained"
                        color="success"
                    >
                        Create Account
                    </Button>
                    <Button
                        sx={{ borderRadius: 10, textTransform: "capitalize", paddingX: 5 }}
                        onClick={() => setAddMember(false)}
                        variant="contained"
                        color="error"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    return (
        <div className="w-full flex  flex-col  min-h-64  justify-center items-center">
            {getAddMemberDialog()}
            <ToastContainer />

            {loading && (
                <div className="p-2  rounded-full border-[2px] h-20 w-20 flex justify-center items-center  ">
                    <CircularProgress size={50} />
                </div>
            )}
            {users && (
                <div className="rounded-xl flex-row flex gap-10 w-full mt-5 mb-5 self-start p-4 shadow-sm bg-white ">
                    <div>
                        <strong className="text-[20px]">Total Staff Members</strong>

                        <br />

                        <span className=" text-[30px] text-green-600 font-bold">
                            {getFilteredUsers()?.length}{" "}
                        </span>
                    </div>
                    <div className="w-[700px] flex-row flex">
                        <SearchField
                            w={500}
                            setQuery={setQuery}
                            query={query}
                            placeholder={"Search with Kitchen Id,User ID, Order ID"}
                        />
                        <Button variant="contained" onClick={() => setAddMember(true)}>
                            Add New Member
                        </Button>
                    </div>
                </div>
            )}

            {users && <BasicTable list={getFilteredUsers()} loadStaff={getUsers} />}
        </div>
    );
}
